module.exports = __webpack_public_path__ + "img/logo.d1a0c289.svg";